/**
 * Route helper utilities shared across the application.
 */

/**
 * Checks whether the current page is a public interview route.
 *
 * A page is considered a public interview route when:
 *  - The pathname starts with "/interview/", OR
 *  - A `candidate_interview_id` key exists in sessionStorage
 *    (set during an active candidate session).
 *
 * Returns `false` on the server (SSR) or when sessionStorage is unavailable.
 */
export const isPublicInterviewRoute = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const path = window.location.pathname || '';
  if (path.startsWith('/interview/')) {
    return true;
  }

  try {
    return Boolean(sessionStorage.getItem('candidate_interview_id'));
  } catch {
    return false;
  }
};
